import { IconLoader } from '@ui/src';
import CurrenciesPositionHeader from './currencies-position-header';
import CurrenciesPositionItem from './currencies-position-item';
import { CurrenciesPositionTypes } from './types';

import cn from './currencies-position.module.css';

const CurrenciesPosition = ({
  currenciesPosition,
  isLoading,
}: CurrenciesPositionTypes) => {
  let content = (
    <div className={cn.reportLoader}>
      <IconLoader />
    </div>
  );

  if (!isLoading && currenciesPosition) {
    content = (
      <div>
        {currenciesPosition?.currencies?.map((item) => (
          <CurrenciesPositionItem
            key={item.currency.id}
            currencyReport={item}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={cn.currenciesPositionBlock}>
      <div className={cn.curreniesPositionBlockContent}>
        <CurrenciesPositionHeader />
        {content}
      </div>
    </div>
  );
};

export default CurrenciesPosition;
